<template>
	<div class="end-round" :class="{ win: status === 'win', lost: status === 'lost' }">
		<div class="next-word" :class="'next-word-' + color">
			<span class="word-counter">{{ currentWord + 1 }}/{{ wordsPerGame }}</span>
			<div class="bar"></div>
			<ArrowButton v-if="$store.state.players.length == 1 && wordsPerGame - 1 != currentWord" :color="color" @click.native="$emit('nextWord', true)" label="Prossima parola" />
			<ArrowButton v-if="$store.state.players.length == 1 && wordsPerGame - 1 == currentWord" :color="color" @click.native="$emit('nextWord', true)" label="Punteggio" />
			<ArrowButton v-if="$store.state.players.length > 1 && currentPlayer == 0" :color="color" @click.native="$emit('nextWord', true)" label="Squadra Fucsia" />
			<ArrowButton v-if="$store.state.players.length > 1 && currentPlayer == 1" :color="color" @click.native="$emit('nextWord', true)" label="Squadra Rosa" />
		</div>
		<GotoIntro v-if="status == 'win' || status == 'lost'" />
	</div>
</template>

<script>
import ArrowButton from "@/components/ArrowButton.vue";
import GotoIntro from "@/components/GotoIntro.vue";

export default {
	components: { ArrowButton, GotoIntro },
	props: ["status", "currentWord", "wordsPerGame", "color", "currentPlayer"],
};
</script>
<style scoped lang="scss">
.end-round {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	overflow: hidden;
	bottom: 0;
	width: 100%;
	height: 0;
	z-index: 1;
	transition: all 0.3s;
	&.win {
		height: 100%;
		background: #86e127;
	}
	&.lost {
		height: 100%;
		background: #ff5454;
	}
	.next-word {
		position: absolute;
		z-index: 100;
		display: inline-flex;
		justify-content: space-between;
		align-items: center;
		max-width: px(1024);
		width: 95%;
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;

		&.next-word-orange {
			.word-counter {
				background: $mondadori-orange;
			}
			.bar {
				background: $mondadori-orange;
			}
		}

		&.next-word-pink {
			.word-counter {
				background: $mondadori-pink;
			}
			.bar {
				background: $mondadori-pink;
			}
		}
		.word-counter {
			display: inline-block;
			color: #fff;
			border-radius: px(10);
			height: px(30);
			line-height: px(30);
			padding: 0 px(10);
			outline: 0.25rem solid white;
		}
		.bar {
			height: 0.2rem;
			width: 100%;
			background: #fff !important;
			display: inline-block;
		}
	}
}
</style>
